import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SpinnerCircles from './Spinner/SpinerCircles';
import './customModal.css';

/** Dynamic modal with basic UI
 * @param {string} header - Modal title
 * @param {Element} children - Body component of modal
 * @param {boolean} isOpen - state of modal, open on close
 * @param {Function} onCancel - callback function when cancel button is cliced
 * @param {Function} onConfirm - callback function when confirm button is cliced
 * @param {Element} closeHeader - component to close modal from header e.g Cross icon ui
 * @param {boolean} wider - increase modal width
 * @param {boolean} close - close will be set as title for cancel button
 * @param {boolean} submitDisplay - submit button will display on modal
 * @param {boolean} loading - show spinner
 * @param {Function} onSave - callback function when save button is clicked
 * @param {string} saveBtnText - text for save button
 * @param {boolean} saveLoading - show spinner on save button
 * @param {boolean} medium - increase modal width to 50%
 */
const CustomModal = ({
  header,
  children,
  isOpen,
  onConfirm,
  onCancel,
  onDelete,
  closeHeader,
  wider,
  close,
  showCustomButton,
  customButtonText,
  confirmBtnText,
  hideFooter,
  confirmDisabled,
  loading,
  onSave,
  saveBtnText,
  saveLoading,
  customButtomColor,
  medium,
}) => {
  const style = { width: onSave ? '30%' : null };
  const modalClass = wider ? 'create-box-modal' : medium ? 'medium-box-modal' : 'small-box-modal';
  return (
    <Modal isOpen={isOpen} className={`${modalClass} custom-scroll-modal`}>
      {header && <ModalHeader className='scroll-modal-fixed-header' close={closeHeader}>{header}</ModalHeader>}
      <ModalBody className='modal-scroll-body'>{children}</ModalBody>
      {!hideFooter && (
        <ModalFooter className="d-flex justify-content-evenly align-items-center">
          {showCustomButton ? (
            <Button style={style} color="primary" onClick={onCancel}>
              {customButtonText || 'Ok'}
            </Button>
          ) : (
            onCancel ? <Button style={style} outline color="secondary" onClick={onCancel}>
              {close ? 'Close' : 'Cancel'}
            </Button> : null
          )}
          {onSave ? (
            <Button style={style} color="primary" onClick={onSave}>
              {saveLoading ? <SpinnerCircles /> : saveBtnText || 'Save'}
            </Button>
          ) : null}
          {onConfirm && (
            <Button
              style={style}
              color={customButtomColor}
              disabled={confirmDisabled}
              onClick={onConfirm}
            >
              {loading ? <SpinnerCircles /> : confirmBtnText || 'Submit'}
            </Button>
          )}
           {onDelete && (
            <Button
              style={style}
              color={customButtomColor}
              disabled={confirmDisabled}
              onClick={onDelete}
            >
              {loading ? <SpinnerCircles /> : 'Delete' || 'Submit'}
            </Button>
          )}
          
        </ModalFooter>
      )}
    </Modal>
  );
};

export default CustomModal;
